import styled from 'styled-components';

import { responsive } from '@/utils';

export const ChipsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));
  padding-bottom: ${responsive.spacing['xlarge']};
  gap: ${responsive.spacing['medium']};
`;
